import { TIMEZONES } from "@tellescope/types-models";

export const convertStringToTimezone = (str: string) =>
  TIMEZONES.find((item) => item.toLowerCase() === str.toLowerCase());
